import { postWhatsappCloudCall } from "../api/client";

/**
 * Estabelece áudio WebRTC com a perna de negócio após webhook `calls` (session SDP).
 * Fluxo alinhado à doc Meta: pre_accept com SDP answer, depois accept (quando aplicável).
 */
export async function startWhatsappCloudVoiceSession({
  channelId,
  callId,
  remoteSdp,
  remoteSdpType,
}) {
  if (!channelId || !callId || !remoteSdp) {
    throw new Error("Parâmetros ausentes para sessão de voz WhatsApp Cloud.");
  }

  const sdpType = String(remoteSdpType || "").toLowerCase();
  const pc = new RTCPeerConnection({
    iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
  });

  const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
  stream.getTracks().forEach((t) => pc.addTrack(t, stream));

  if (sdpType === "offer") {
    await pc.setRemoteDescription({ type: "offer", sdp: remoteSdp });
    const answer = await pc.createAnswer();
    await pc.setLocalDescription(answer);

    await postWhatsappCloudCall(channelId, {
      messaging_product: "whatsapp",
      call_id: callId,
      action: "pre_accept",
      session: { sdp_type: "answer", sdp: answer.sdp },
    });

    await postWhatsappCloudCall(channelId, {
      messaging_product: "whatsapp",
      call_id: callId,
      action: "accept",
      session: { sdp_type: "answer", sdp: answer.sdp },
    });
  } else if (sdpType === "answer") {
    await pc.setRemoteDescription({ type: "answer", sdp: remoteSdp });
  } else {
    try {
      pc.close();
    } catch (_) {}
    stream.getTracks().forEach((t) => t.stop());
    throw new Error(`Tipo de SDP não suportado: ${remoteSdpType || "(vazio)"}`);
  }

  return { pc, stream };
}
